/* ============================================
   L'CRÉATIF Theme JavaScript
   ============================================ */

(function() {
  'use strict';

  /* --- HEADER SCROLL BEHAVIOR --- */
  const header = document.querySelector('.header');
  if (header) {
    const announcementBar = document.querySelector('.announcement-bar');
    const threshold = announcementBar ? announcementBar.offsetHeight : 0;
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > threshold) {
        header.classList.add('header--scrolled');
        header.classList.remove('header--transparent');
      } else {
        header.classList.remove('header--scrolled');
        if (header.dataset.transparent === 'true') {
          header.classList.add('header--transparent');
        }
      }
      lastScroll = currentScroll;
    }, { passive: true });
  }

  /* --- SLIDESHOW --- */
  class Slideshow {
    constructor(el) {
      this.el = el;
      this.slides = el.querySelectorAll('.slideshow__slide');
      this.dots = el.querySelectorAll('.slideshow__dot');
      this.current = 0;
      this.interval = parseInt(el.dataset.interval) || 6000;
      this.timer = null;

      if (this.slides.length > 1) {
        this.start();
        this.dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.goTo(i));
        });
      }
      if (this.slides.length > 0) {
        this.slides[0].classList.add('is-active');
        if (this.dots[0]) this.dots[0].classList.add('is-active');
      }
    }

    goTo(index) {
      this.slides[this.current].classList.remove('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.remove('is-active');
      this.current = index;
      this.slides[this.current].classList.add('is-active');
      if (this.dots[this.current]) this.dots[this.current].classList.add('is-active');
      this.restart();
    }

    next() {
      this.goTo((this.current + 1) % this.slides.length);
    }

    start() {
      this.timer = setInterval(() => this.next(), this.interval);
    }

    restart() {
      clearInterval(this.timer);
      this.start();
    }
  }

  document.querySelectorAll('.slideshow').forEach(el => new Slideshow(el));

  /* --- TABBED COLLECTIONS --- */
  document.querySelectorAll('.featured-collections').forEach(section => {
    const tabs = section.querySelectorAll('.featured-collections__tab');
    const panels = section.querySelectorAll('.featured-collections__panel');

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => {
        tabs.forEach(t => t.classList.remove('is-active'));
        panels.forEach(p => p.classList.remove('is-active'));
        tab.classList.add('is-active');
        if (panels[i]) panels[i].classList.add('is-active');
      });
    });
  });

  /* --- COUNTDOWN TIMER --- */
  class CountdownTimer {
    constructor(el) {
      this.el = el;
      this.endDate = new Date(el.dataset.endDate).getTime();
      this.days = el.querySelector('[data-days]');
      this.hours = el.querySelector('[data-hours]');
      this.minutes = el.querySelector('[data-minutes]');
      this.seconds = el.querySelector('[data-seconds]');

      if (this.endDate) {
        this.update();
        this.timer = setInterval(() => this.update(), 1000);
      }
    }

    update() {
      const now = Date.now();
      const diff = Math.max(0, this.endDate - now);

      const d = Math.floor(diff / (1000 * 60 * 60 * 24));
      const h = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const m = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const s = Math.floor((diff % (1000 * 60)) / 1000);

      if (this.days) this.days.textContent = String(d).padStart(2, '0');
      if (this.hours) this.hours.textContent = String(h).padStart(2, '0');
      if (this.minutes) this.minutes.textContent = String(m).padStart(2, '0');
      if (this.seconds) this.seconds.textContent = String(s).padStart(2, '0');

      if (diff === 0) clearInterval(this.timer);
    }
  }

  document.querySelectorAll('.countdown-timer').forEach(el => new CountdownTimer(el));

  /* --- BEFORE/AFTER SLIDER --- */
  class BeforeAfterSlider {
    constructor(el) {
      this.el = el;
      this.overlay = el.querySelector('.before-after__overlay');
      this.divider = el.querySelector('.before-after__divider');
      this.handle = el.querySelector('.before-after__handle');
      this.isDragging = false;

      this.pos = 50;

      this.el.addEventListener('mousedown', (e) => this.startDrag(e));
      this.el.addEventListener('touchstart', (e) => this.startDrag(e), { passive: true });
      document.addEventListener('mousemove', (e) => this.drag(e));
      document.addEventListener('touchmove', (e) => this.drag(e), { passive: true });
      document.addEventListener('mouseup', () => this.endDrag());
      document.addEventListener('touchend', () => this.endDrag());

      // Keyboard accessibility
      if (this.handle) {
        this.handle.setAttribute('tabindex', '0');
        this.handle.setAttribute('role', 'slider');
        this.handle.setAttribute('aria-label', 'Use the left and right arrow keys to compare the images');
        this.handle.setAttribute('aria-valuemin', '0');
        this.handle.setAttribute('aria-valuemax', '100');
        this.handle.setAttribute('aria-valuenow', '50');
        this.handle.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') { e.preventDefault(); this.setPos(this.pos - 4); }
          else if (e.key === 'ArrowRight') { e.preventDefault(); this.setPos(this.pos + 4); }
        });
      }
    }

    setPos(x) {
      x = Math.max(5, Math.min(95, x));
      this.pos = x;
      if (this.overlay) this.overlay.style.width = x + '%';
      if (this.divider) this.divider.style.left = x + '%';
      if (this.handle) {
        this.handle.style.left = x + '%';
        this.handle.setAttribute('aria-valuenow', Math.round(x));
      }
    }

    startDrag(e) {
      this.isDragging = true;
      this.el.style.cursor = 'ew-resize';
    }

    drag(e) {
      if (!this.isDragging) return;
      const rect = this.el.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      this.setPos(((clientX - rect.left) / rect.width) * 100);
    }

    endDrag() {
      this.isDragging = false;
      this.el.style.cursor = 'ew-resize';
    }
  }

  document.querySelectorAll('.before-after').forEach(el => new BeforeAfterSlider(el));

  /* --- TESTIMONIALS CAROUSEL --- */
  document.querySelectorAll('[data-testimonials]').forEach(carousel => {
    const slides = carousel.querySelectorAll('[data-testimonial-slide]');
    const section = carousel.closest('.testimonials');
    const dots = section ? section.querySelectorAll('[data-testimonial-dot]') : [];
    if (slides.length < 2) return;
    let current = 0;
    let timer = null;
    const go = (i) => {
      current = (i + slides.length) % slides.length;
      slides.forEach((s, n) => s.classList.toggle('is-active', n === current));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === current));
    };
    const start = () => { timer = setInterval(() => go(current + 1), 6000); };
    const restart = () => { clearInterval(timer); start(); };
    dots.forEach((dot, i) => dot.addEventListener('click', () => { go(i); restart(); }));
    go(0);
    start();
  });

  /* --- MARQUEE DUPLICATION --- */
  document.querySelectorAll('.scrolling-marquee__track').forEach(track => {
    const clone = track.innerHTML;
    track.innerHTML += clone;
  });

  /* --- ACCORDION --- */
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      const item = trigger.closest('.accordion__item');
      const isOpen = item.classList.contains('is-open');
      item.closest('.accordion').querySelectorAll('.accordion__item').forEach(i => i.classList.remove('is-open'));
      if (!isOpen) item.classList.add('is-open');
    });
  });

  /* --- NEWSLETTER POPUP --- */
  const popupOverlay = document.querySelector('.popup-overlay');
  if (popupOverlay) {
    const closeBtn = popupOverlay.querySelector('.popup__close');
    const dismissed = sessionStorage.getItem('popup-dismissed');

    if (!dismissed) {
      setTimeout(() => popupOverlay.classList.add('is-active'), 4000);
    }

    if (closeBtn) {
      closeBtn.addEventListener('click', () => {
        popupOverlay.classList.remove('is-active');
        sessionStorage.setItem('popup-dismissed', 'true');
      });
    }

    popupOverlay.addEventListener('click', (e) => {
      if (e.target === popupOverlay) {
        popupOverlay.classList.remove('is-active');
        sessionStorage.setItem('popup-dismissed', 'true');
      }
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && popupOverlay.classList.contains('is-active')) {
        popupOverlay.classList.remove('is-active');
        sessionStorage.setItem('popup-dismissed', 'true');
      }
    });
  }

  /* --- CART DRAWER --- */
  const cartToggle = document.querySelector('[data-cart-toggle]');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose = document.querySelector('.cart-drawer__close');

  function openCart() {
    // This theme has no cart drawer (maison uses a full /cart page). Without this
    // guard the body scroll-lock below would fire on every AJAX add and freeze the page.
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    if (cartOverlay) cartOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('is-open');
    if (cartOverlay) cartOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* --- MOBILE MENU --- */
  const mobileToggle = document.querySelector('.header__mobile-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  const mobileClose = document.querySelector('.mobile-menu__close');

  if (mobileToggle && mobileMenu) {
    mobileToggle.addEventListener('click', () => {
      mobileMenu.classList.toggle('is-open');
      document.body.style.overflow = mobileMenu.classList.contains('is-open') ? 'hidden' : '';
    });
    if (mobileClose) {
      mobileClose.addEventListener('click', () => {
        mobileMenu.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    }
  }

  /* --- ADD TO CART (AJAX) --- */
  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (!addBtn) return;
    e.preventDefault();

    // Prefer the selected variant + quantity from the enclosing form.
    const form = addBtn.closest('form');
    let variantId = addBtn.dataset.variantId;
    let quantity = 1;
    if (form) {
      const idField = form.querySelector('[name="id"]');
      if (idField && idField.value) variantId = idField.value;
      const qtyField = form.querySelector('[name="quantity"]');
      if (qtyField && qtyField.value) quantity = parseInt(qtyField.value) || 1;
    }

    if (!variantId) return;

    const originalLabel = addBtn.textContent.trim();
    addBtn.disabled = true;
    addBtn.textContent = 'Adding…';

    const restore = (msg) => {
      addBtn.textContent = msg;
      setTimeout(() => { addBtn.textContent = originalLabel; addBtn.disabled = false; }, 1400);
    };

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: quantity }] })
      });

      if (res.ok) {
        restore('Added!');
        var live = document.getElementById('a11y-status');
        if (live) live.textContent = 'Item added to your cart.';
        openCart();
        updateCartDrawer();
      } else {
        restore('Error');
      }
    } catch (err) {
      addBtn.disabled = false;
      addBtn.textContent = originalLabel;
    }
  });

  async function updateCartDrawer() {
    try {
      const res = await fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } });
      const cart = await res.json();
      const itemsContainer = document.querySelector('.cart-drawer__items');
      const totalEl = document.querySelector('.cart-drawer__total-price');
      const countEl = document.querySelector('[data-cart-count]');
      const footer = document.querySelector('[data-cart-footer]');

      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.hidden = cart.item_count === 0;
      }

      if (footer) footer.hidden = cart.item_count === 0;

      if (totalEl) {
        totalEl.textContent = formatMoney(cart.total_price);
      }

      if (itemsContainer) {
        if (cart.items.length === 0) {
          itemsContainer.innerHTML = '<p class="cart-drawer__empty">Your cart is empty</p>';
        } else {
          itemsContainer.innerHTML = cart.items.map(item => `
            <div class="cart-item">
              <img class="cart-item__image" src="${esc(item.image)}" alt="${esc(item.product_title)}" width="80" height="80">
              <div class="cart-item__info">
                <p class="cart-item__title">${esc(item.product_title)}</p>
                <p class="cart-item__variant">Qty: ${esc(item.quantity)}</p>
                <p class="cart-item__price">${formatMoney(item.final_line_price)}</p>
              </div>
            </div>
          `).join('');
        }
      }
    } catch (err) {
      console.error('Cart update failed:', err);
    }
  }

  // Escape API-supplied strings before they touch innerHTML (attribute + text safe).
  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatMoney(cents) {
    return 'Dhs. ' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  /* --- QUANTITY SELECTOR --- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.quantity-selector__btn');
    if (!btn) return;

    const input = btn.closest('.quantity-selector').querySelector('.quantity-selector__input');
    if (!input) return;

    const min = parseInt(input.min);
    const floor = isNaN(min) ? 1 : min;
    let val = parseInt(input.value) || floor;
    if (btn.dataset.action === 'decrease') val = Math.max(floor, val - 1);
    if (btn.dataset.action === 'increase') val = val + 1;
    input.value = val;

    // On the cart page, auto-submit the update so totals reflect immediately.
    const cartForm = input.closest('[data-cart-form]');
    if (cartForm && input.name === 'updates[]') {
      const updateBtn = cartForm.querySelector('[name="update"]');
      if (updateBtn) updateBtn.click(); else cartForm.submit();
    }
  });

  /* --- PRODUCT PAGE THUMBNAILS --- */
  document.querySelectorAll('.product-page__thumbnail').forEach(thumb => {
    thumb.addEventListener('click', () => {
      const gallery = thumb.closest('.product-page__gallery');
      const images = gallery.querySelectorAll('.product-page__main-image');
      const thumbs = gallery.querySelectorAll('.product-page__thumbnail');
      const index = parseInt(thumb.dataset.index);

      images.forEach(img => img.classList.remove('is-active'));
      thumbs.forEach(t => t.classList.remove('is-active'));

      if (images[index]) images[index].classList.add('is-active');
      thumb.classList.add('is-active');
    });
  });

  /* --- PRODUCT PAGE ACCORDION --- */
  document.querySelectorAll('.accordion__header').forEach(header => {
    header.addEventListener('click', () => {
      const accordion = header.closest('.accordion');
      const content = accordion.querySelector('.accordion__content');
      const isOpen = accordion.classList.contains('is-open');

      accordion.closest('.product-page__info')?.querySelectorAll('.accordion').forEach(a => {
        a.classList.remove('is-open');
        a.querySelector('.accordion__content').style.maxHeight = null;
      });

      if (!isOpen) {
        accordion.classList.add('is-open');
        content.style.maxHeight = content.scrollHeight + 'px';
        header.setAttribute('aria-expanded', 'true');
      } else {
        header.setAttribute('aria-expanded', 'false');
      }
    });
  });

  /* --- SCROLL-DOWN CHEVRON --- */
  const scrollDown = document.querySelector('.slideshow__scroll-down');
  if (scrollDown) {
    scrollDown.addEventListener('click', () => {
      const slideshow = scrollDown.closest('.slideshow');
      if (slideshow && slideshow.nextElementSibling) {
        slideshow.nextElementSibling.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }

  /* --- LAZY IMAGE LOADING --- */
  if ('IntersectionObserver' in window) {
    const imgObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
            img.removeAttribute('data-src');
          }
          imgObserver.unobserve(img);
        }
      });
    }, { rootMargin: '200px' });

    document.querySelectorAll('img[data-src]').forEach(img => imgObserver.observe(img));
  }

  /* --- SCROLL REVEAL ANIMATION --- */
  if ('IntersectionObserver' in window) {
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 200px 0px' });

    document.querySelectorAll('.reveal-on-scroll').forEach(el => revealObserver.observe(el));

    // Safety net: if anything hasn't revealed shortly after load, show it.
    window.addEventListener('load', () => {
      setTimeout(() => {
        document.querySelectorAll('.reveal-on-scroll:not(.is-revealed)').forEach(el => {
          const rect = el.getBoundingClientRect();
          if (rect.top < window.innerHeight + 200) el.classList.add('is-revealed');
        });
      }, 400);
    });
  } else {
    document.querySelectorAll('.reveal-on-scroll').forEach(el => el.classList.add('is-revealed'));
  }

  /* --- PRODUCT STICKY ADD-TO-CART BAR --- */
  const stickyBar = document.querySelector('[data-product-sticky]');
  const mainAddBtn = document.querySelector('.product-page__add-to-cart');
  if (stickyBar && mainAddBtn && 'IntersectionObserver' in window) {
    const stickyObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', show);
        stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
      });
    }, { threshold: 0 });
    stickyObserver.observe(mainAddBtn);
  }

  /* --- PREDICTIVE SEARCH DRAWER --- */
  const searchDrawer = document.getElementById('search-drawer');
  if (searchDrawer) {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchInput = searchDrawer.querySelector('[data-predictive-input]');
    const searchResults = searchDrawer.querySelector('[data-predictive-results]');

    const openSearch = () => {
      searchDrawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'true');
      setTimeout(() => { if (searchInput) searchInput.focus(); }, 120);
    };
    const closeSearch = () => {
      searchDrawer.classList.remove('is-open');
      document.body.style.overflow = '';
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
    };

    if (searchToggle) searchToggle.addEventListener('click', openSearch);
    searchDrawer.querySelectorAll('[data-search-close]').forEach(el => el.addEventListener('click', closeSearch));
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchDrawer.classList.contains('is-open')) closeSearch();
    });

    let searchTimer = null;
    if (searchInput && searchResults) {
      searchInput.addEventListener('input', () => {
        const q = searchInput.value.trim();
        clearTimeout(searchTimer);
        if (q.length < 2) { searchResults.innerHTML = ''; return; }
        searchTimer = setTimeout(async () => {
          try {
            const url = '/search/suggest.json?q=' + encodeURIComponent(q) +
              '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
            const res = await fetch(url);
            const data = await res.json();
            const products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (!products.length) {
              searchResults.innerHTML = '<p class="predictive-empty">No matches for &ldquo;' +
                q.replace(/</g, '&lt;') + '&rdquo;. Press Enter to search everything.</p>';
              return;
            }
            searchResults.innerHTML = products.map(p => {
              const img = (p.featured_image && p.featured_image.url) ? p.featured_image.url : (p.image || '');
              return '<a class="predictive-result" href="' + esc(p.url) + '">' +
                (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
                '<span><span class="predictive-result__title">' + esc(p.title) + '</span><br>' +
                '<span class="predictive-result__price">' + esc(p.price || '') + '</span></span></a>';
            }).join('');
          } catch (err) { /* network error — let the form submit handle it */ }
        }, 250);
      });
    }
  }

  /* --- COLLECTION GRID VIEW TOGGLE --- */
  document.querySelectorAll('.collection-toolbar__view-toggles').forEach(group => {
    const scope = group.closest('.collection__main') || document;
    const grid = scope.querySelector('[data-collection-grid]');
    const buttons = group.querySelectorAll('[data-grid-view]');
    const apply = (v) => {
      if (grid) grid.setAttribute('data-grid-view', v);
      buttons.forEach(b => {
        const active = b.dataset.gridView === v;
        b.classList.toggle('is-active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
    };
    const stored = localStorage.getItem('collection-grid-view');
    if (stored) apply(stored);
    buttons.forEach(b => b.addEventListener('click', () => {
      apply(b.dataset.gridView);
      localStorage.setItem('collection-grid-view', b.dataset.gridView);
    }));
  });

  /* --- COLLECTION FILTER DRAWER (mobile) --- */
  const facetsPanel = document.querySelector('[data-facets]');
  if (facetsPanel) {
    const openBtn = document.querySelector('[data-facets-open]');
    if (openBtn) openBtn.addEventListener('click', () => {
      facetsPanel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    });
    facetsPanel.querySelectorAll('[data-facets-close]').forEach(el => el.addEventListener('click', () => {
      facetsPanel.classList.remove('is-open');
      document.body.style.overflow = '';
    }));
  }
})();
